import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {InfoAlert} from '@igp/shared/components/alerts';
import {KeyValueCell, KeyValueColumn, KeyValueTable} from '@igp/shared/components/key-value-table';
import {makeStyles} from 'tss-react/mui';

const localized = defineMessages({
    username: {
        id: 'AddUserSuccessModal_username',
        defaultMessage: 'Username:',
    },
    password: {
        id: 'AddUserSuccessModal_password',
        defaultMessage: 'Temporary Password:',
    },
    playerId: {
        id: 'AddUserSuccessModal_playerId',
        defaultMessage: 'Player ID:',
    },
    note: {
        id: 'AddUserSuccessModal_note',
        defaultMessage: 'Please note: The user must change their password upon first login',
    },
});

const useStyles = makeStyles()(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}));

type AddUserSuccessModalProps = {
    username: string;
    password: string;
    playerId?: string;
};

export function AddUserSuccessModal({username, password, playerId}: AddUserSuccessModalProps) {
    const {formatMessage} = useIntl();
    const {classes} = useStyles();
    return (
        <div className={classes.container}>
            <KeyValueTable mode="card">
                <KeyValueColumn keyWidth="lg">
                    <KeyValueCell title={formatMessage(localized.username)}>{username}</KeyValueCell>
                    <KeyValueCell title={formatMessage(localized.password)}>{password}</KeyValueCell>
                    {playerId && <KeyValueCell title={formatMessage(localized.playerId)}>{playerId}</KeyValueCell>}
                </KeyValueColumn>
            </KeyValueTable>
            <InfoAlert title={localized.note} />
        </div>
    );
}
